module.exports = __webpack_public_path__ + "img/cpu.766799b5.svg";